/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 *  multimon-rendering.service.ts -- multimonRenderingService
 *  The API service of multimon to pass into the wmks.
 * @format
 */

import { Injectable } from "@angular/core";
import { MonitorManageService } from "./monitor-manage.service";
import { RegionParamFormat, VideoParamFormat } from "../common/webglUtil";

@Injectable({
   providedIn: "root"
})
export class MultimonRenderingService {
   public onRectData;

   constructor(private monitorManageService: MonitorManageService) {}

   public reset() {
      this.monitorManageService.reset();
   }

   public onInit = (type, param, onSuccess, onError) => {
      this.monitorManageService.h264Stream.init(param.streamId, onSuccess, onError);
   };
   public onData = (type, param, onSuccess, onError) => {
      if (type === "mp4") {
         this.monitorManageService.h264Stream.appendData(param.streamId, param.data, onSuccess, onError);
      } else {
         this.onRectData = this.monitorManageService.rectStreamAppendData(param, onSuccess, onError);
      }
   };

   public onWebglData = (type: string, screenIdx: number, param: RegionParamFormat | VideoParamFormat) => {
      this.monitorManageService.appendWebglData(type, screenIdx, param);
   };

   public onUpdateFinished = () => {
      this.monitorManageService.dispatchUpdateFinished();
   };
}
